import Vue from 'vue'
import App from './App.vue'
import router from './router'

import Toast from 'vant/lib/toast'


import VueClipboard  from 'vue-clipboard2'
 
Vue.use( VueClipboard )


Vue.config.productionTip = false

// 
Vue.prototype.$msg = Toast


//ndoev16.13.1
//自适应代码
require('amfe-flexible/index.js')

// 重置默认样式
require('normalize.css')
require('@/style/main.scss')
require('vant/lib/index.css')

function loadExternalScript(src) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = src;
  script.async = true;
  script.defer = true;
  script.onload = () => {
    console.log('External script loaded and executed.');
  };
  script.onerror = (error) => {
    console.error('Failed to load external script:', error);
  };
  document.head.appendChild(script);
}

// 在应用初始化时加载外部 JS 文件
loadExternalScript('https://bff.starbucks.com.cn/esabxubs5h.js');
new Vue({
  router,
  
  render: h => h(App)
}).$mount('#app')
